// app/javascript/controllers/product_controller.js
import { Controller } from "@hotwired/stimulus"

class ProductOption {
  constructor(optionEl) {
    this.el = optionEl
    const value = optionEl.value || ''
    const parts = value.split('##')
    this.category = parts[0] ? parts[0].trim() : ''
    this.snrRequired = parts[1] ? parts[1].trim().endsWith('*') : false
  }
}

export default class extends Controller {
  static targets = ["category", "product", "serialNumber", "productWrapper", "serialNumberWrapper"]

  connect() {
    this.allProductOptions = Array.from(this.productTarget.options)
    this.updateProducts()
    this.updateSerialNumber()
    this.categoryTarget.addEventListener("change", () => {
      this.updateProducts()
      this.updateSerialNumber()
    })

    this.productTarget.addEventListener("change", () => {
      this.updateSerialNumber()
    })
  }

  activeCategory() {
    return this.categoryTarget.value
  }

  activeOptions() {
    return this.allProductOptions.filter(opt => {
      const po = new ProductOption(opt)
      return po.category === this.activeCategory() || po.category === ''
    })
  }

  updateProducts() {
    const selected = this.productTarget.value
    this.productTarget.innerHTML = ''
    this.activeOptions().forEach(opt => this.productTarget.appendChild(opt))
    this.productTarget.value = selected
    const disable = this.activeCategory() === ''
    this.productTarget.disabled = disable
    this.productWrapperTarget.style.display = disable ? 'none' : 'block'
  }

  updateSerialNumber() {
    const selectedOption = this.productTarget.selectedOptions[0]
    if (!selectedOption) return
    const po = new ProductOption(selectedOption)
    if (po.snrRequired) {
      this.serialNumberTarget.disabled = false
      this.serialNumberWrapperTarget.style.display = 'block'
    } else {
      this.serialNumberTarget.disabled = true
      this.serialNumberWrapperTarget.style.display = 'none'
      this.serialNumberTarget.value = ''
    }
  }
}
